module.exports = __webpack_public_path__ + "static/media/home-setup-1-mobile.e17712ac.jpg";